const initialState = {
  listQuote: [],
};
const FETCH_QUOTE = "fetch_quotes";

export const fetchQuote = (data) => ({
  type: FETCH_QUOTE,
  payload: data,
});

export default (state = initialState, action) => {
    const {type, payload} = action;
  switch (type) {
    case FETCH_QUOTE: {
      return {
        ...state,
        listQuote: [...payload],
      };
    }
    default:
      return state;
  }
};
